var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-autocomplete"},[_c('md-autocomplete',{attrs:{"filterList":_vm.userFilter,"list":_vm.users,"print-attribute":_vm.field},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }